import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';
import { IValidationResult } from '../../../services/Validation/interfaces';
import { ICDV3ViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { ICDViewItemGroups } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItemCollection';

export interface IPresentationCdItems {
  deletedItems: ICDV3ViewItem[];
  items: ICDViewItemGroups;
  changesSaved: boolean;
}

export interface ICdBuilderState {
  cdItems: { [orderId: string]: IPresentationCdItems };
  validation: { [orderId: string]: IValidationResult | undefined };
  cdItemsFetchStatus: IFetchStatus;
  cdItemsError: Error | null;
  refiCondition: string | null;
  updateCdItemsFetchStatus: IFetchStatus;
  updateCdItemsError: Error | null;
}

export const cdBuilderInitialState: ICdBuilderState = {
  cdItems: {},
  validation: {},
  cdItemsFetchStatus: createDefaultFetch(),
  cdItemsError: null,
  refiCondition: null,
  updateCdItemsFetchStatus: createDefaultFetch(),
  updateCdItemsError: null,
};
